import { render, staticRenderFns } from "./QutaEdit.vue?vue&type=template&id=b613da82&scoped=true&"
import script from "./QutaEdit.vue?vue&type=script&lang=js&"
export * from "./QutaEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b613da82",
  null
  
)

export default component.exports